/** Rotta assoluta della home (mappa). */
export const HOME_ROUTE = '/home';
